import "es6-shim";
import "./app.css"
import * as ReactDOM from 'react-dom';
import * as React from 'react';
import { Provider } from 'react-redux';
import Main from './components/Main/Main.container';
import configureStore, { sagaMiddleWare } from './configureStore';
import rootSaga from "./sagas";
import registerServiceWorker from './registerServiceWorker';
import "./utilities/ArrayExtensions";
import 'font-awesome/css/font-awesome.min.css';
import './utilities/StringExtensions';
// initialize store from the rootReducer from the store folder.
const store = configureStore();

sagaMiddleWare.run(rootSaga);

/***
 * <Provider store>
 * Makes the Redux store available to the connect() calls in the component hierarchy below.
 * Inject the application store into all the childs. This way all the children can choose what values
 * from the store they require and become available in the props. */
ReactDOM.render(
    (
        <Provider
            store={store}
        >
            <Main />
        </Provider>
    ),
    document.getElementById("app")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/app.tsx